import { useToken } from '@ori/auth';
import { TranslationsNamespaceProvider, TranslationsProvider } from '@ori/i18n';
import { TestIdProvider } from '@ori/testid-generator';
import { Suspense } from 'react';
import type { FC } from 'react';

import { APP_TEAM_NAME, APP_NAME, defaultTranslations, translationsNamespace } from './constants';
import { ApiProvider, NovageSkincareAdvisor } from './containers';
import { ConfigurationProvider } from './contexts';
import type { AppConfiguration } from './models';

interface AppProps {
  configuration: AppConfiguration;
}

export const App: FC<AppProps> = ({ configuration }) => {
  const { currentLanguage, staticApiUrl, tenant } = configuration;
  const { token } = useToken();

  return (
    <ConfigurationProvider value={configuration}>
      <TestIdProvider
        team={APP_TEAM_NAME}
        project={APP_NAME}
      >
        <Suspense fallback={null}>
          <ApiProvider>
            <TranslationsProvider
              currentLanguage={currentLanguage}
              defaultTranslationsWithNamespaces={{ [translationsNamespace]: defaultTranslations }}
              clientFetchConfiguration={{
                tenant,
                token,
                baseUrl: staticApiUrl,
                // eslint-disable-next-line no-console -- we need to log errors
                onError: console.error,
              }}
            >
              <TranslationsNamespaceProvider namespace={translationsNamespace}>
                <NovageSkincareAdvisor />
              </TranslationsNamespaceProvider>
            </TranslationsProvider>
          </ApiProvider>
        </Suspense>
      </TestIdProvider>
    </ConfigurationProvider>
  );
};
